module.exports = __webpack_public_path__ + "static/media/OH.a965d7ec.wav";